/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

import { SessionDialogContext, SessionDialogFormType } from '@/data/context/sessionDialogCtx';
import { useCallback, useContext } from 'react';

export const useSessionDialog = () => {
	const { sessionDialogOpen, setSessionDialogOpen, selectedForm, setSelectedForm } =
		useContext(SessionDialogContext);

	const openSessionDialog = useCallback(
		(form: SessionDialogFormType) => {
			setSelectedForm(form);
			setSessionDialogOpen(true);
		},
		[setSelectedForm, setSessionDialogOpen]
	);

	const closeSessionDialog = useCallback(() => {
		setSelectedForm(null);
		setSessionDialogOpen(false);
	}, [setSelectedForm, setSessionDialogOpen]);

	return { sessionDialogOpen, openSessionDialog, closeSessionDialog, selectedForm };
};
